/**
 * kapcsolat form megjelenítő komponens
 * @author Koppany Kiss 2017.05.22.
 */
import grafikonMegjelenitoTemplate from './grafikon-megjelenito.pug';

const MODULE_NAME = 'grafikonMegjelenito';
class GrafikonMegjelenitoController {
	constructor() {
		'ngInject';
	}

	$onInit() {
		this.chartOptionsGiven = angular.copy(this.chartOptions);
		this.formModelGiven = angular.copy(this.formModel);
	}

	$onChanges(changeObject) {
		if (!changeObject.chartOptions.isFirstChange()) {
			this.chartOptionsGiven = angular.copy(this.chartOptions);
		}

		if (!changeObject.formModel.isFirstChange()) {
			this.formModelGiven = angular.copy(this.formModel);
		}
	}
}

export default angular.module(MODULE_NAME, [])
	.component('grafikonMegjelenito', {
		controller: GrafikonMegjelenitoController,
		template: grafikonMegjelenitoTemplate(),
		bindings: {
			chartOptions: '<',
			formModel: '<'
		}
	}).name;




// WEBPACK FOOTER //
// ../source/application/grafikon-container/grafikon-megjelenito/grafikon-megjelenito.js